'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderArchiveComponent = exports.podOrderArchiveComponent = {
    template: require('./pod-order-archive.html'),
    controllerAs: 'vm',
    bindings: {
        orders: '<'
    },
    controller: ["common", "gettextCatalog", function podOrderArchiveController(common, gettextCatalog) {
        'ngInject';

        var vm = this;

        vm.search = search;
        vm.clear = clear;

        vm.$onInit = init;
        vm.model = {
            results: [],
            paging: {
                totalItems: 23,
                itemsPerPage: 12,
                page: 1,
                pageCount: 2,
                pageNumbers: [{
                    index: 1,
                    isHiddenOnMobile: false
                }, {
                    index: 2,
                    isHiddenOnMobile: false
                }]
            }
        };

        function init() {
            common.setTitle(gettextCatalog.getString('Al mijn verzendingen'));
        }

        function search() {}

        function clear() {}
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/pod-order-archive.js
// module id = 864
// module chunks = 0